import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-message-dialog',
  template: `
    <h1 mat-dialog-title *ngIf="data.title" [ngClass]="data.titleClass">{{ data.title }}</h1>
    <div mat-dialog-content *ngIf="data.message" [ngClass]="data.contentClass" >{{ data.message }}</div>
    <div mat-dialog-content *ngIf="data.contentHtml" [ngClass]="data.contentClass" [innerHtml]="sanitizedHtml"></div>
    <div mat-dialog-actions align="end">
      <button *ngIf="data.cancelTitle" mat-stroked-button (click)="handleCancel($event)">{{ data.cancelTitle }}</button>
      <!-- okColor が null 明示 ⇒ color 属性なし -->
      <button *ngIf="data.okColor === null" mat-button (click)="handleOk($event)">
        {{ data.okTitle ? data.okTitle : 'OK' }}
      </button>

      <!-- okColor が undefined または値あり ⇒ primary または指定色 -->
      <button *ngIf="data.okColor !== null" mat-button 
              [color]="data.okColor ? data.okColor : 'primary'" 
              (click)="handleOk($event)">
        {{ data.okTitle ? data.okTitle : 'OK' }}
      </button>

    </div>
  `,
  styles: []
})
export class MessageDialogComponent {

  sanitizedHtml: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title?: string,
      message?: string,
      okTitle?: string,
      okColor?: string,
      contentHtml?: string,
      titleClass?: string,
      contentClass?: string,
      cancelTitle?: string,
      onOk?: (event: Event) => void; // クリックイベント用の関数を親から受け取る
      onCancel?: (event: Event) => void; // クリックイベント用の関数を親から受け取る
    },
    private sanitizer: DomSanitizer
  ) {
    this.dialogRef.disableClose = true;
    if (data.contentHtml) {
      this.sanitizedHtml = this.sanitizeHtml(data.contentHtml);
    }

  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngAfterViewInit(): void {
  }

  handleOk(event: Event) {
    if (this.data.onOk) {
      this.data.onOk(event); // OKボタンのクリックイベント
    }
    this.dialogRef.close(true);
  }

  handleCancel(event: Event) {
    if (this.data.onCancel) {
      this.data.onCancel(event); // キャンセルボタンのクリックイベント
    }
    this.dialogRef.close(false);
  }

}
